import { GetServerSideProps } from 'next';
import { hotelPageQuery, getPageAndGlobalProps, HotelPageQuery } from '@honeycomb/data';
import { HotelPageContext, HotelPageParams } from 'pages/hotels/[estabId]';

// eslint-disable-next-line no-restricted-exports
export { default } from 'pages/hotels/[estabId]';
export const getServerSideProps: GetServerSideProps<HotelPageQuery, HotelPageParams> = async (
    context: HotelPageContext
) => {
    const { estabId } = context.params as HotelPageParams;
    return getPageAndGlobalProps<HotelPageQuery, HotelPageContext>(context, hotelPageQuery(estabId));
};
